import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SEO from "@/components/feature/SEO";

export default function NotFound() {
  return (
    <>
      <SEO
        title="页面未找到 - 51漫画"
        description="抱歉，您访问的页面不存在。请返回51漫画首页浏览海量免费漫画资源。"
        canonicalUrl="https://www.51manhua.com/"
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-24 pb-16">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 text-center py-20">
            <div className="w-24 h-24 mx-auto flex items-center justify-center rounded-3xl bg-background-200 text-foreground-400 mb-6">
              <i className="ri-emotion-sad-line text-4xl" />
            </div>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
              404
            </h1>
            <p className="text-foreground-500 mb-2">抱歉，您访问的页面不存在</p>
            <p className="text-sm text-foreground-400 mb-8">该页面可能已被移除或地址输入有误</p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/"
                className="px-6 py-2.5 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-home-4-line mr-1.5" />
                返回首页
              </Link>
              <Link
                to="/category/rexue"
                className="px-6 py-2.5 bg-background-200 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-300 transition-colors whitespace-nowrap"
              >
                <i className="ri-book-read-line mr-1.5" />
                浏览漫画
              </Link>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}